export default [
  {
    path: '/examination-results/:key?',
    name: 'examination-results',
    component: () => import('@/views/examinationResult/ExaminationResultTabs.vue'),
    meta: {},
  },
];
